import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import useDocMeta from "../hooks/useDocMeta";
import ContactSection from "../components/ContactSection";
import { META } from "../mock";
import TEAM from "../data/team.json";

const SOCIAL_ICONS = { facebook: Facebook, instagram: Instagram, linkedin: Linkedin };

function RichText({ text }) {
  return text.split("**").map((part, i) =>
    i % 2 ? <strong key={i} className="font-semibold text-black">{part}</strong> : part
  );
}

function BioBlock({ b }) {
  if (b.type === "ul") {
    return (
      <ul className="list-disc pl-6 space-y-1.5">
        {b.items.map((it, i) => <li key={i}><RichText text={it} /></li>)}
      </ul>
    );
  }
  return <p><RichText text={b.text} /></p>;
}

export default function TeamMember() {
  const { slug } = useParams();
  const m = TEAM.find((t) => t.slug === slug);
  useDocMeta({ title: m ? `${m.name} | AwareHub` : META.team.title, description: META.team.description });
  if (!m) return <Navigate to="/about/team" replace />;

  return (
    <div>
      <section className="bg-white pt-28 sm:pt-32 pb-12 sm:pb-16" data-testid="team-member-page">
        <div className="max-w-[930px] mx-auto px-5 grid md:grid-cols-2 gap-8 md:gap-4 items-start">
          <img src={m.image} alt={m.name} className="w-full h-auto" data-testid="team-member-photo" />
          <div className="font-[Montserrat] text-[15px] leading-[1.75] text-[#292f33]">
            <h1 className="font-[Cinzel] text-[32px] leading-tight text-black" data-testid="team-member-name">{m.name}</h1>
            <p className="mt-5 uppercase tracking-[0.2em] text-[15px] text-[#54595f]" data-testid="team-member-role">{m.role}</p>
            <div className="mt-4 space-y-4" data-testid="team-member-bio">
              {m.bio.map((b, i) => <BioBlock key={i} b={b} />)}
            </div>
            {m.socials.length > 0 && (
              <div className="mt-4 flex gap-4" data-testid="team-member-socials">
                {m.socials.map((s) => {
                  const Icon = SOCIAL_ICONS[s.network];
                  return Icon ? (
                    <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.network}
                      className="text-[#5fa9ab] hover:text-[#017477] transition-colors">
                      <Icon className="h-5 w-5" />
                    </a>
                  ) : null;
                })}
              </div>
            )}
          </div>
        </div>
      </section>

      <ContactSection />
    </div>
  );
}
